import { Button } from "antd";
import styled from "styled-components";

export const DefaultContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 5px;
`;

export const NewRegister = styled(Button)`
  height: 40px;
  width: 140px;
  margin-left: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: space-between;
`;
